var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { deepmerge } from 'deepmerge-ts';
import * as ExecutionEnvironment from 'exenv';
import is from 'is-lite';
export var canUseDOM = ExecutionEnvironment.canUseDOM;
export var portalId = 'react-floater-portal';
export function enhanceProps(props) {
    return __assign({ autoOpen: false, debug: false, disableFlip: false, disableHoverToClick: false, event: 'click', eventDelay: 0.4, hideArrow: false, offset: 15, placement: 'bottom', showCloseButton: false, styles: {}, target: null, wrapperOptions: {
            position: false,
        } }, props);
}
export function getFallbackPlacements(placement) {
    if (placement.startsWith('left')) {
        return ['top', 'bottom'];
    }
    if (placement.startsWith('right')) {
        return ['bottom', 'top'];
    }
    return undefined;
}
export function getModifiers(modifiers) {
    var defaultOptions = {
        flip: {
            name: 'flip',
            enabled: true,
            options: {
                padding: 20,
            },
        },
        preventOverflow: {
            name: 'preventOverflow',
            enabled: true,
            options: {
                padding: 10,
            },
        },
    };
    return deepmerge(defaultOptions, modifiers || {});
}
export function isFixed(el) {
    if (!el) {
        return false;
    }
    var nodeName = el.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        return false;
    }
    if (getComputedStyle(el).position === 'fixed') {
        return true;
    }
    return el.parentNode instanceof HTMLElement ? isFixed(el.parentNode) : false;
}
export function isMobile() {
    return 'ontouchstart' in window && /Mobi/.test(navigator.userAgent);
}
/**
 * Log method calls if debug is enabled
 */
export function log(_a) {
    var data = _a.data, _b = _a.debug, debug = _b === void 0 ? false : _b, title = _a.title;
    /* eslint-disable no-console */
    var logFn = console.log;
    if (debug && title && data) {
        console.groupCollapsed("%creact-floater: ".concat(title), 'color: #9b00ff; font-weight: bold; font-size: 12px;');
        if (Array.isArray(data)) {
            data.forEach(function (d) {
                if (is.plainObject(d) && d.key) {
                    logFn.apply(console, [d.key, d.value]);
                }
                else {
                    logFn.apply(console, [d]);
                }
            });
        }
        else {
            logFn.apply(console, [data]);
        }
        console.groupEnd();
    }
    /* eslint-enable */
}
export function mergeModifier(modifier, customModifier) {
    return deepmerge(modifier, customModifier || {});
}
export function off(element, eventType, handler, options) {
    if (options === void 0) { options = false; }
    element.removeEventListener(eventType, handler, options);
}
export function on(element, eventType, handler, options) {
    if (options === void 0) { options = false; }
    element.addEventListener(eventType, handler, options);
}
export function once(element, eventType, handler, options) {
    if (options === void 0) { options = false; }
    var nextCB;
    // eslint-disable-next-line prefer-const
    nextCB = function (event) {
        handler(event);
        off(element, eventType, nextCB);
    };
    on(element, eventType, nextCB, options);
}
export function randomId() {
    return "rf-".concat(Math.round(Math.random() * 1e5));
}
//# sourceMappingURL=helpers.js.map